// Flow types automatically removed

import { createFragmentContainer, graphql } from 'react-relay/legacy';
import DisplayPromoCode from './DisplayPromoCode';
import get from 'lodash.get';

const DisplayPromoCodeWrapper = props => {
    const promotion = props?.viewer?.activePromotion;
    const isShippingPromotion = promotion?.isShippingPromotion;

    if (
        (props?.onlyShippingPromos && !isShippingPromotion) ||
        (props?.excludeShippingPromos && isShippingPromotion)
    ) {
        return null;
    }

    return (
        <DisplayPromoCode
            {...props}
            promotion={promotion}
            item={get(props, 'viewer.item') || null}
            user={get(props, 'viewer.user') || null}
        />
    );
};

export { DisplayPromoCodeWrapper };
export default createFragmentContainer(DisplayPromoCodeWrapper, {
    viewer: graphql`
        fragment DisplayPromoCodeWrapper_viewer on Viewer {
            ...DisplayPromoCode_viewer
            activePromotion(userId: $userId, itemId: $optionalItemId) {
                ...DisplayPromoCode_promotion
                isShippingPromotion
            }
            user(userId: $userId) @include(if: $hasUserId) {
                ...DisplayPromoCode_user
            }
            item(itemId: $itemId, pageType: PROMO) @include(if: $hasItemId) {
                ...DisplayPromoCode_item
            }
        }
    `,
});
